import { Builder } from '@builder.io/react';
import classNames from 'classnames';
import { isLeft } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/function';

import { ExpertCard, ScrollableWithType } from '@catawiki/cata-style';

import { nullableData } from '@/shared/utils/http';

import {
  fetchExpert as fetchRemoteExpert,
  RemoteExpert,
} from '../../api/buyer';

export interface Expert {
  id: number;
  mainImage: string;
  name: string;
  subtitle: string;
  url: string;
}

type ExpertsInput = { expertId: number; subtitle: string };

interface BuilderInput {
  expertsInput: ExpertsInput[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attributes?: any;
}

type Props = BuilderInput & {
  locale: string;
  experts: Expert[];
};

/**
 * @deprecated The component should not be used
 */
export const ExpertsList = ({ experts = [], attributes }: Props) => (
  <div
    {...attributes}
    className={classNames('p-experts-list', attributes?.className)}
  >
    <ScrollableWithType
      keyPrefix="expert"
      type="lots"
      render={(imageContainerRef) =>
        Array(experts.length)
          .fill(undefined)
          .map((_, index) => {
            const expert = experts[index];

            if (!expert) {
              return null;
            }
            return (
              <ExpertCard
                imageContainerRef={imageContainerRef}
                key={expert.id}
                url={expert.url}
                mainImage={expert.mainImage}
                name={expert.name}
                expertise={expert.subtitle}
              />
            );
          })
      }
    />
  </div>
);

async function fetchExpert(expertId: number, subtitle: string, locale: string) {
  const eitherExperts = await fetchRemoteExpert(expertId, locale);

  if (isLeft(eitherExperts)) {
    console.error(eitherExperts.left);
  }

  const expert = pipe(eitherExperts, nullableData) || ({} as RemoteExpert);

  return {
    ...expert,
    mainImage: expert.main_image,
    subtitle,
  };
}

export function dataFetcher(locale: string) {
  return async ({ expertsInput = [] }: BuilderInput) => {
    if (expertsInput.length === 0) return [];
    const remoteExperts = await Promise.all(
      expertsInput.map((input) =>
        fetchExpert(input.expertId, input.subtitle, locale)
      )
    );

    return {
      locale,
      experts: remoteExperts,
    };
  };
}

export function componentRegister() {
  const name = 'ExpertsList';
  Builder.registerComponent(ExpertsList, {
    name,
    image: `https://${process.env.NEXT_PUBLIC_BASE_DOMAIN}/assets/pages/images/icons/experts.svg`,
    inputs: [
      {
        name: 'expertsInput',
        type: 'list',
        subFields: [
          { name: 'expertId', type: 'number' },
          { name: 'subtitle', type: 'string' },
        ],
      },
    ],
    hideFromInsertMenu: true,
    noWrap: true,
  });
  return name;
}
